import React from 'react';
import PropTypes from 'prop-types';
import { IconButton, Box } from '@mui/material';
import { Check as OKIcon, Close as CancelIcon } from '@mui/icons-material';

export function OkCancelButtons({ handleConfirm, handleCancel }) {
	return (
		<Box
			component="div"
			sx={{
				position: 'relative',
				display: 'flex',
				pr: 1,
				pl: 1,
				alignItems: 'center',
				justifyContent: 'center',
			}}
		>
			<IconButton
				edge="start"
				color="primary"
				size="small"
				aria-label="ok"
				onClick={(e) => {
					e.stopPropagation();
					handleConfirm();
				}}
			>
				<OKIcon sx={{ m: 0.25, fontSize: '1.3rem' }} />
			</IconButton>
			<IconButton
				edge="end"
				size="small"
				aria-label="cancel"
				onClick={(e) => {
					e.stopPropagation();
					handleCancel();
				}}
			>
				<CancelIcon sx={{ m: 0.25, fontSize: '1.3rem' }} />
			</IconButton>
		</Box>
	);
}

OkCancelButtons.propTypes = {
	handleConfirm: PropTypes.func.isRequired,
	handleCancel: PropTypes.func.isRequired,
};
